import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const LocationIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C12.4155 0 16 3.58447 16 8C16 10.2993 14.8527 12.6659 13.4122 14.6532C11.4009 17.4287 8.88564 19.4522 8.88564 19.4522V19.4527C8.36847 19.8687 7.63154 19.8687 7.11436 19.4527V19.4522C7.11436 19.4522 4.59906 17.4287 2.58776 14.6532C1.14729 12.6659 0 10.2993 0 8C0 3.58447 3.58447 0 8 0ZM8 4.70588C9.81788 4.70588 11.2941 6.18212 11.2941 8C11.2941 9.81788 9.81788 11.2941 8 11.2941C6.18212 11.2941 4.70588 9.81788 4.70588 8C4.70588 6.18212 6.18212 4.70588 8 4.70588Z"
        fill="currentColor"
      />
    </svg>
  )
})

LocationIcon.displayName = 'LocationIcon'
